export default function GameStarted() {
	return <div>GAME HAS STARTED</div>;
}
